import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';

const CapitalEdit = ({ match }) => {
    const { id, mid } = useParams();
    const history = useHistory();

    // Auth Context
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    // State Variables
    const [formData, setFormData] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // if the master type have changes then display the corresponding return view's 
    ///////////////////////////////////////////////////////////////////////////////////
    //Owner Details / Captial
    const [ContactNumber1, setContactNumber1] = useState("");
    const [ContactNumber2, setContactNumber2] = useState("");
    const [Email, setEmail] = useState("");
    const [AddressLine1, setAddressLine1] = useState("");
    const [AddressLine2, setAddressLine2] = useState("");

    //CustomerOrSupplier
    const [CSEmail, setCSEmail] = useState("");
    const [CSAddressLine1, setCSAddressLine1] = useState("");
    const [CSAddressLine2, setCSAddressLine2] = useState("");
    const [CSDeliveryAddressLine1, setCSDeliveryAddressLine1] = useState("");
    const [CSDeliveryAddressLine2, setCSDeliveryAddressLine2] = useState("");
    const [CSContactNumber1, setCSContactNumber1] = useState("");
    const [CSContactNumber2, setCSContactNumber2] = useState("");
    const [Location, setLocation] = useState("");
    const [Pincode, setPincode] = useState("");
    const [MRPLCode, setMRPLCode] = useState("");
    const [PanNumber, setPanNumber] = useState("");
    const [GSTNumber, setGSTNumber] = useState("");
    const [CreditDays, setCreditDays] = useState("");
    const [CreditLimit, setCreditLimit] = useState("");
    const [customerType, setCustomerType] = useState(1);

    //credit radio [customer type]
    const handleCustomerTypeChange = (event) => {
        setCustomerType(event.target.value);
    };


    //Bank 
    const [AccountName, setAccountName] = useState("");
    const [BranchName, setBranchName] = useState("");
    const [IFSCCode, setIFSCCode] = useState("");
    const [BKAddressLine1, setBKAddressLine1] = useState("");
    const [BKAddressLine2, setBKAddressLine2] = useState("");
    const [BKContactNumber, setBKContactNumber] = useState("");

    //Staff
    const [STAddressLine1, setSTAddressLine1] = useState("");
    const [STAddressLine2, setSTAddressLine2] = useState("");
    const [STContactNumber1, setSTContactNumber1] = useState("");
    const [STContactNumber2, setSTContactNumber2] = useState("");
    const [STEmail, setSTEmail] = useState("");
    const [isLoginNeeded, setIsLoginNeeded] = useState(false);
    // if IsloginNeeded is true then display the firstname and second name feilds
    const [STFirstName, setSTFirstName] = useState("");
    const [STSecondName, setSTSecondName] = useState("");
    const [STuserName, setSTUserName] = useState("");
    useEffect(() => {
        const generatedUserName = `${STFirstName.toLowerCase()}_${STSecondName.toLowerCase()}`;
        // Limit the username to a maximum length of 15 characters
        const limitedUserName = generatedUserName.slice(0, 12);
        setSTUserName(limitedUserName);

    }, [STFirstName, STSecondName]);

    //AccountHead
    const [CGSTRate, setCGSTRate] = useState("");
    const [SGSTRate, setSGSTRate] = useState("");
    const [HSNCode, setHSNCode] = useState("");
    const [IsExpenseOrIncome, setIsExpenseOrIncome] = useState(true);

    const handleAccoundHeadChange = (event) => {
        const value = event.target.value === "true"; // Converts "true"/"false" string to boolean
        setIsExpenseOrIncome(value);
    };

    //Assets
    const [ATAmount, setATAmount] = useState("");
    const [ATCGSTRate, setATCGSTRate] = useState("");
    const [ATSGSTRate, setATSGSTRate] = useState("");
    const [ATHSNCode, setATHSNCode] = useState("");
    const [ATDepreciation, setATDepreciation] = useState("");

    // Branch Select for Staff Creation

    const [BranchTypeOptions, setBranchTypeOptions] = useState([]);
    const [selectedBranchType, setSelectedBranchType] = useState("");

    const fetchBranchType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('BranchApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(branch => ({
                    value: branch.Id,
                    label: branch.Name
                }));
                setBranchTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleBranchTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedBranchType(selectedOption);
    };

    useEffect(() => {
        fetchBranchType();
    }, []);


    ////////////////////////////////////////////////////////////////////////

    // Fetch Data Function
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchCapitalData();
    }, [id, mid, isAuthenticated, token, logout]);

    // const fetchCapitalData = async () => {
    //     if (mid === 1) {
    //         try {
    //             const response = await fetchData('CapitalApi', `/CapitalDataDetails/${id}/${mid}`, token);
    //             if (response.responseCode === '1111') {
    //                 const data = response.response_data;
    //                 console.log('Fetched Data:', data);
    //                 setFormData(data);
    //                 setIsLoading(false);
    //             } else {
    //                 setErrorMessage("Failed to load data.");
    //                 setIsLoading(false);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //             setErrorMessage("Error fetching data.");
    //             setIsLoading(false);
    //         }
    //     }
    //     else if (mid === 2) {
    //         try {
    //             const response = await fetchData('SupplierAndCustomerApi', `/SupplierAndCustomerDataDetails/${id}/${mid}`, token);
    //             if (response.responseCode === '1111') {
    //                 const data = response.response_data;
    //                 console.log('Fetched Data:', data);
    //                 setFormData(data);
    //                 setIsLoading(false);
    //             } else {
    //                 setErrorMessage("Failed to load data.");
    //                 setIsLoading(false);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //             setErrorMessage("Error fetching data.");
    //             setIsLoading(false);
    //         }
    //     }
    // };

    const fetchCapitalData = async () => {
        try {
            let apiEndpoint = '';
            let url = '';

            if (mid === '1') { // Changed to string comparison if mid is string in params
                apiEndpoint = 'CapitalApi';
                url = `/CapitalDataDetails/${id}/${mid}`;
            } else if (mid === '2') {
                apiEndpoint = 'SupplierAndCustomerApi';
                url = `/SupplierAndCustomerDataDetails/${id}/${mid}`;
            }
            else if (mid === '3') {
                apiEndpoint = 'BankApi';
                url = `/BankDataDetails/${id}/${mid}`;
            }
            else if (mid === '4') {
                apiEndpoint = 'StaffApi';
                url = `/StaffDataDetails/${id}/${mid}`;
            }
            else if (mid === '5') {
                apiEndpoint = 'AccountHeadApi';
                url = `/AccountHeadDataDetails/${id}/${mid}`;
            }
            else if (mid === '6') {
                apiEndpoint = 'MasterApi';
                url = `/MasterDataDetails/${id}/${mid}`;
            }
            else {
                apiEndpoint = 'AssetsApi';
                url = `/AssetDataDetails/${id}/${mid}`;
            }

            // Fetch data from the appropriate API endpoint
            const response = await fetchData(apiEndpoint, url, token);

            if (response.responseCode === '1111') {
                const data = response.response_data;
                console.log('Fetched Data:', data); // Debugging: Log the fetched data
                setFormData(data); // Set the formData with the fetched data
            } else {
                setErrorMessage("Failed to load data.");
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setErrorMessage("Error fetching data.");
        } finally {
            // Set loading to false once data fetch attempt is complete
            setIsLoading(false);
        }
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    //Balance Sheet
    const [balancesheetOptions, setBalanceSheetOptions] = useState([]);
    const [selectedBalanceSheetType, setSelectedBalanceSheetType] = useState("");

    const fetchBalanceSheet = async () => {
        try {
            const response = await fetchData('MasterApi', `/BalanceSheetData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(balance => ({
                    value: balance.Id,
                    label: balance.Name
                }));
                setBalanceSheetOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleBalanceSheetChange = (selectedOption) => {
        setSelectedBalanceSheetType(selectedOption);
    };

    useEffect(() => {
        fetchBalanceSheet();
    }, []);


    //MasterType
    const [MasterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [selectedMasterTypeId, setSelectedMasterTypeId] = useState("");


    const fetchMasterType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('MasterApi', `/MasterTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(master => ({
                    value: master.Id,
                    label: master.Name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleMasterTypeChange = (selectedOption) => {
        setSelectedMasterType(selectedOption);
        setSelectedMasterTypeId(selectedOption.value);

    };

    useEffect(() => {
        fetchMasterType();
    }, []);

    //  Invoice Type

    const [InvoiceTypeOptions, setInvoiceTypeOptions] = useState([]);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("");

    const fetchInvoiceType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('MasterApi', `/InvoiceTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(invoice => ({
                    value: invoice.Id,
                    label: invoice.Name
                }));
                setInvoiceTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleInvoiceTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedInvoiceType(selectedOption);
    };

    useEffect(() => {
        fetchInvoiceType();
    }, []);

    const [GrpMasterTypeOptions, setGrpMasterTypeOptions] = useState([]);
    const [selectedGrpMasterType, setGrpSelectedMasterType] = useState("");
    const [selectedGrpMasterTypeId, setSelectedGrpMasterTypeId] = useState("");

    const fetchMasterGroup = async () => {
        try {

            const response = await fetchData('MasterGroup', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(master => ({
                    value: master.Id,
                    label: master.Name
                }));
                setGrpMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching MasterGroup:', error);
        }
    };
    const handleGrpMasterTypeChange = (selectedOption) => {

        // setGrpSelectedMasterType(selectedOption.label);
        setGrpSelectedMasterType(selectedOption);
        setSelectedGrpMasterTypeId(selectedOption.value);
    };
    useEffect(() => {
        fetchMasterGroup();
    }, []);



    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        );
    }


    // masterType change data save
    const addRecord = async (e) => {
        e.preventDefault();

        if (selectedMasterType === "Staff") {

            const StaffData = {

                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                ContactNumber1: STContactNumber1,
                ContactNumber2: STContactNumber2,
                Email: STEmail,
                AddressLine1: STAddressLine1,
                AddressLine2: STAddressLine2,
                CreatedBy: userId,
                CreatedDate: new Date(),
                IsLoginNeeded: isLoginNeeded,
                FirstName: STFirstName,
                LastName: STSecondName,
                UserName: STuserName,
                BranchId: selectedBranchType.value,

            };

            postData('StaffApi', StaffData, token)
                .then((response) => {
                    console.log('Staff Created success:', response);
                    setSuccessMessage("Staff Created successfully!");
                    setErrorMessage("");
                    setSTFirstName("");
                    setSTSecondName("");
                    setSTUserName("");
                    setSelectedBalanceSheetType("");
                    setSTContactNumber1("");
                    setSTContactNumber2("");
                    setSTAddressLine1("");
                    setSTAddressLine2("");
                    setSTEmail("");
                    setSelectedMasterType("");
                    //fetchtableData();

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Assets") {

            const AssetsData = {

                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                Amount: ATAmount,
                Depreciation: ATDepreciation,
                CGSTRate: ATCGSTRate,
                SGSTRate: ATSGSTRate,
                HSNCode: ATHSNCode,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('AssetsApi', AssetsData, token)
                .then((response) => {
                    console.log('Assets Created success:', response);
                    setSuccessMessage("Assets Created successfully!");
                    setErrorMessage("");
                    setATAmount("");
                    setATCGSTRate("");
                    setATSGSTRate("");
                    setATDepreciation("");
                    setATHSNCode("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    // fetchtableData();

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Assets Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Bank") {

            const BankData = {

                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                AccountName: AccountName,
                BranchName: BranchName,
                IFSCCode: IFSCCode,
                AddressLine1: BKAddressLine1,
                AddressLine2: BKAddressLine2,
                ContactNumber: BKContactNumber,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('BankApi', BankData, token)
                .then((response) => {
                    console.log('Bank Created success:', response);
                    setSuccessMessage("Bank Created successfully!");
                    setErrorMessage("");
                    setBKAddressLine1("");
                    setBKAddressLine2("");
                    setBKContactNumber("");
                    setAccountName("");
                    setBranchName("");
                    setIFSCCode("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Bank Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Capital") {

            const CapitalData = {

                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                ContactNumber1: ContactNumber1,
                ContactNumber2: ContactNumber2,
                Email: Email,
                AddressLine1: AddressLine1,
                AddressLine2: AddressLine2,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('CapitalApi', CapitalData, token)
                .then((response) => {
                    console.log('CapitalData Created success:', response);
                    setSuccessMessage("CapitalData Created successfully!");
                    setErrorMessage("");
                    setAddressLine1("");
                    setAddressLine2("");
                    setContactNumber1("");
                    setContactNumber2("");
                    setEmail("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('CapitalData Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Customer Or Supplier") {

            const CustomerOrSupplierData = {

                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                // MasterGroupId: selectedGrpMasterTypeId,
                BalanceSheetHeadId: formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                SalesExecutiveId: null,
                InvoiceTypeId: selectedInvoiceType.value,
                ContactNumber1: CSContactNumber1,
                ContactNumber2: CSContactNumber2,
                Email: CSEmail,
                AddressLine1: CSAddressLine1,
                AddressLine2: CSAddressLine2,
                DeliveryAddressLine1: CSDeliveryAddressLine1,
                DeliveryAddressLine2: CSDeliveryAddressLine2,
                Location: Location,
                PinCode: Pincode,
                GSTNumber: GSTNumber,
                PanNumber: PanNumber,
                // MRPLCode: MRPLCode,
                CreditDays: CreditDays,
                CreditLimit: CreditLimit,
                CustomerType: customerType,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('SupplierAndCustomerApi', CustomerOrSupplierData, token)
                .then((response) => {
                    console.log('CustomerOrSupplierData Created success:', response);
                    setSuccessMessage("CustomerOrSupplierData Created successfully!");
                    setErrorMessage("");
                    setCSAddressLine1("");
                    setCSAddressLine2("");
                    setCSDeliveryAddressLine1("");
                    setCSDeliveryAddressLine2("");
                    setCSContactNumber1("");
                    setCSContactNumber2("");
                    setCSEmail("");
                    setLocation("");
                    setGSTNumber("");
                    setPanNumber("");
                    setSelectedInvoiceType("");
                    //setSelectedSalesManType("");
                    setMRPLCode("");
                    setPincode("");
                    setCreditDays("");
                    setCreditLimit("");
                    setCustomerType("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('CustomerOrSupplierData Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Account Head") {

            const AccountHeadData = {

                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CGSTRate: CGSTRate,
                SGSTRate: SGSTRate,
                HSNCode: HSNCode,
                IsExpenseOrIncome: IsExpenseOrIncome,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('AccountHeadApi', AccountHeadData, token)
                .then((response) => {
                    console.log('Account Head Created success:', response);
                    setSuccessMessage("Account Head Created successfully!");
                    setErrorMessage("");
                    setCGSTRate("");
                    setSGSTRate("");
                    setHSNCode("");
                    setIsExpenseOrIncome("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Account Head Create error:', error);
                    setIsLoading(false);
                });
        }

        else {
            //(selectedMasterType === "Others") 
            const OtherData = {

                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('MasterApi', OtherData, token)
                .then((response) => {
                    console.log('Others Created success:', response);
                    setSuccessMessage("Others Created successfully!");
                    setErrorMessage("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    // fetchtableData();

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Others Create error:', error);
                    setIsLoading(false);
                });
        }
    };


    // handle submit [updatedata]
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.masterType === "Staff") {

            const MasterData = {
                CompanyId: companyId,
                Id: formData.MasterId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value || formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const StaffData = {
                Id: formData.StaffId,
                MasterId: formData.MasterId,
                ContactNumber1: formData.ContactNumber1,
                ContactNumber2: formData.ContactNumber2,
                Email: formData.Email,
                AddressLine1: formData.AddressLine1,
                AddressLine2: formData.AddressLine2,
                BranchId: formData.BranchId,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const updatedData = {
                Master: MasterData,
                StaffDetails: StaffData
            };


            try {
                await updateData('StaffApi', `${id}`, updatedData, token);
                history.push('/MasterIndex');
            } catch (error) {
                console.error('Error updating record:', error);
                setErrorMessage("Error updating record.");
                setIsLoading(false);
            }
        }

        else if (formData.masterType === "Assets") {

            const MasterData = {
                CompanyId: companyId,
                Id: formData.MasterId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value || formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const AssetsData = {
                Amount: formData.Amount,
                Id: formData.AssetId,
                MasterId: formData.MasterId,
                Depreciation: formData.Depreciation,
                CGSTRate: formData.CGSTRate,
                SGSTRate: formData.SGSTRate,
                HSNCode: formData.HSNCode,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const updatedData = {
                Master: MasterData,
                AssetsDetails: AssetsData
            };


            try {
                await updateData('AssetsApi', `${formData.MasterId}`, updatedData, token);
                history.push('/MasterIndex');
            } catch (error) {
                console.error('Error updating record:', error);
                setErrorMessage("Error updating record.");
                setIsLoading(false);
            }
        }

        else if (formData.masterType === "Bank") {

            const MasterData = {
                CompanyId: companyId,
                Id: formData.MasterId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value || formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const BankData = {
                Id: formData.BankId,
                MasterId: formData.MasterId,
                AccountName: formData.AccountName,
                BranchName: formData.BranchName,
                IFSCCode: formData.IFSCCode,
                AddressLine1: formData.AddressLine1,
                AddressLine2: formData.AddressLine2,
                ContactNumber: formData.ContactNumber,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const updatedData = {
                Master: MasterData,
                BankDetails: BankData
            };


            try {
                await updateData('BankApi', `${formData.MasterId}`, updatedData, token);
                history.push('/MasterIndex');
            } catch (error) {
                console.error('Error updating record:', error);
                setErrorMessage("Error updating record.");
                setIsLoading(false);
            }
        }

        else if (formData.masterType === "Capital") {

            const MasterData = {
                Id: formData.MasterId,
                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value || formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const CapitalData = {
                Id: formData.CapitalId,
                MasterId: formData.MasterId,
                ContactNumber1: formData.ContactNumber1,
                ContactNumber2: formData.ContactNumber2,
                Email: formData.Email,
                AddressLine1: formData.AddressLine1,
                AddressLine2: formData.AddressLine2,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,


            };

            const updatedData = {
                Master: MasterData,
                OwnerDetails: CapitalData
            };


            try {
                await updateData('CapitalApi', `${id}`, updatedData, token);
                history.push('/MasterIndex');
            } catch (error) {
                console.error('Error updating record:', error);
                setErrorMessage("Error updating record.");
                setIsLoading(false);
            }
        }

        else if (formData.masterType === "Customer Or Supplier") {

            const MasterData = {
                Id: formData.MasterId,
                CompanyId: companyId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value || formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const CustomerOrSupplierData = {
                Id: formData.CustomerSupplierId,
                MasterId: formData.MasterId,
                SalesExecutiveId: null,
                InvoiceTypeId: selectedInvoiceType.value || formData.InvoiceTypeId,
                ContactNumber1: formData.ContactNumber1,
                ContactNumber2: formData.ContactNumber2,
                Email: formData.Email,
                AddressLine1: formData.AddressLine1,
                AddressLine2: formData.AddressLine2,
                DeliveryAddressLine1: formData.DeliveryAddressLine1,
                DeliveryAddressLine2: formData.DeliveryAddressLine2,
                Location: formData.Location,
                PinCode: formData.PinCode,
                GSTNumber: formData.GSTNumber,
                PanNumber: formData.PanNumber,
                CreditDays: formData.CreditDays,
                CreditLimit: formData.CreditLimit,
                CustomerType: formData.CustomerType,
                CreatedBy: formData.CreatedBy,
                CreatedDate: formData.CreatedDate,
                ModifiedBy: userId,

            };

            const updatedData = {
                Master: MasterData,
                SupplierAndCustomerDetails: CustomerOrSupplierData
            };

            try {
                await updateData('SupplierAndCustomerApi', `${formData.MasterId}`, updatedData, token);
                history.push('/MasterIndex');
            } catch (error) {
                console.error('Error updating record:', error);
                setErrorMessage("Error updating record.");
                setIsLoading(false);
            }
        }

        else if (formData.masterType === "Account Head") {

            const MasterData = {

                CompanyId: companyId,
                Id: formData.MasterId,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value || formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                UpdatedBy: userId,
            };

            const AccountHeadData = {
                Id: formData.AccountHeadId,
                MasterId: formData.MasterId,
                CGSTRate: formData.CGSTRate,
                SGSTRate: formData.SGSTRate,
                HSNCode: formData.HSNCode,
                IsExpenseOrIncome: formData.IsExpenseOrIncome,
                UpdatedBy: userId,

            };

            const updatedData = {
                Master: MasterData,
                IncomeExpenseDetails: AccountHeadData

            };

            try {
                await updateData('AccountHeadApi', `${id}`, updatedData, token);
                history.push('/MasterIndex');
            } catch (error) {
                console.error('Error updating record:', error);
                setErrorMessage("Error updating record.");
                setIsLoading(false);
            }
        }

        else {
            //(selectedMasterType === "Others") 
            const MasterData = {

                CompanyId: companyId,
                Id: formData.Id,
                MasterTypeId: formData.MasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value || formData.BalanceSheetHeadId,
                Name: formData.Name,
                SearchableName: formData.SearchableName,
                Remarks: formData.Remarks,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            const updatedData = {
                Master: MasterData,
            };


            try {
                await updateData('MasterApi', `${id}`, updatedData, token);
                history.push('/MasterIndex');
            } catch (error) {
                console.error('Error updating record:', error);
                setErrorMessage("Error updating record.");
                setIsLoading(false);
            }
        }
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ width: '100%' }}>
            <form onSubmit={handleSubmit} >
                <div className="w-full mb-2 flex">
                    {/* <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Capital - Edit</h6> */}
                    <h6
                        className="block uppercase tracking-wide text-black productHead flex-grow linkcolor"
                        style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                    >
                        {selectedMasterType.label !== formData.masterType && selectedMasterType.label
                            ? selectedMasterType.label
                            : formData.masterType} - Edit
                    </h6>

                    {formData.masterType && (
                        <Button

                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder', cursor: 'pointer' }}
                            onClick={handleSubmit}
                        >
                            <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder', cursor: 'pointer' }} /> UPDATE
                        </Button>
                    )}
                    {selectedMasterType.label !== formData.masterType && selectedMasterType.label && (
                        <Button

                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder', cursor: 'pointer' }}
                            onClick={addRecord}
                        >
                            <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder', cursor: 'pointer' }} /> Add New Record
                        </Button>
                    )}


                    <Button

                        component={Link}
                        to="/MasterIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>
                </div>
                <div className="w-full mb-4 flex">
                    <div className="w-1/3 mr-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="balanceSheet">
                            Balance Sheet
                        </label>
                        <Select
                            value={selectedBalanceSheetType || (formData.Balancesheet ? { value: formData.BalanceSheetHeadId, label: formData.Balancesheet } : '')}
                            onChange={handleBalanceSheetChange}
                            options={balancesheetOptions}
                            placeholder="Balance sheet"
                            isSearchable
                        />
                    </div>

                    <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                            Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            name="Name"
                            placeholder="Enter Name"
                            value={formData.Name}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="searchableName">
                            Searchable Name
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            name="SearchableName"
                            placeholder="Enter Searchable Name"
                            value={formData.SearchableName}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="remarks">
                            Remarks
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            name="Remarks"
                            placeholder="Enter Remarks"
                            value={formData.Remarks}
                            onChange={handleChange}
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div className="w-1/3 mr-2">
                        <label
                            className="block uppercase tracking-wide text-xs font-bold mb-2"
                            htmlFor="masterType"
                        >
                            Master Type
                        </label>

                        <Select
                            value={
                                MasterTypeOptions.find(
                                    (option) => option.label === selectedMasterType?.label
                                ) ||
                                (formData.masterType
                                    ? { value: formData.MasterTypeId, label: formData.masterType }
                                    : null)
                            }
                            onChange={handleMasterTypeChange}
                            options={MasterTypeOptions}
                            placeholder="Master Type"
                            isSearchable
                            isDisabled
                            styles={{
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: "darkred", // Set the color of displayed value to dark red
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: "darkred", // Optionally set the placeholder color
                                }),
                            }}
                        />
                    </div>

                </div>
                {/* Capital */}
                {formData.masterType === "Capital" && (
                    selectedMasterType?.label === "Capital" || selectedMasterType?.label === undefined ? (
                        <>
                            {/* Contact Details Section */}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2"
                                        htmlFor="ContactNumber1"
                                    >
                                        Contact Number 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        placeholder="Contact Number 1"
                                        value={formData.ContactNumber1}
                                        onChange={handleChange}
                                        id="ContactNumber1"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2"
                                        htmlFor="ContactNumber2"
                                    >
                                        Contact Number 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        placeholder="Contact Number 2"
                                        value={formData.ContactNumber2}
                                        onChange={handleChange}
                                        id="ContactNumber2"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2"
                                        htmlFor="Email"
                                    >
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        placeholder="Email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        id="Email"
                                    />
                                </div>
                            </div>

                            {/* Address Details Section */}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/2 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2"
                                        htmlFor="AddressLine1"
                                    >
                                        Address Line 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        placeholder="Address Line 1"
                                        value={formData.AddressLine1}
                                        onChange={handleChange}
                                        id="AddressLine1"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2"
                                        htmlFor="AddressLine2"
                                    >
                                        Address Line 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        placeholder="Address Line 2"
                                        value={formData.AddressLine2}
                                        onChange={handleChange}
                                        id="AddressLine2"
                                    />
                                </div>
                            </div>
                        </>
                    ) : null
                )}

                {formData.masterType === "Customer Or Supplier" && (
                    selectedMasterType?.label === "Customer Or Supplier" || selectedMasterType?.label === undefined ? (
                        <>
                            <div className="w-full mb-4 flex">

                                <div className="w-1/6 mr-2">

                                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Invoice Type
                                    </label>

                                    <Select
                                        value={selectedInvoiceType || (formData.invoicetypes ? { value: formData.InvoiceTypeId, label: formData.invoicetypes } : '')}
                                        onChange={handleInvoiceTypeChange}
                                        options={InvoiceTypeOptions}
                                        isSearchable
                                    />

                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        GST Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='GSTNumber'
                                        value={formData.GSTNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="GST Number"

                                    />
                                </div>
                                <div className="flex justify-end items-center">
                                    <label className="block uppercase tracking-wide text-gray-700 font-bold mr-4">
                                        <input
                                            type="radio"
                                            name="CustomerType"
                                            value="1"
                                            checked={formData.CustomerType.toString() === "1"}
                                            onChange={handleChange}
                                        />
                                        <span style={{ color: 'blue', fontSize: '12px' }}>Customer</span>
                                    </label>
                                    <label className="block uppercase tracking-wide text-gray-700 font-bold mr-4">
                                        <input
                                            type="radio"
                                            name="CustomerType"
                                            value="2"
                                            checked={formData.CustomerType.toString() === "2"}
                                            onChange={handleChange}
                                        />
                                        <span style={{ color: 'brown', fontSize: '12px' }}>Supplier</span>
                                    </label>
                                    <label className="block uppercase tracking-wide text-gray-700 font-bold">
                                        <input
                                            type="radio"
                                            name="CustomerType"
                                            value="3"
                                            checked={formData.CustomerType.toString() === "3"}
                                            onChange={handleChange}
                                        />
                                        <span style={{ color: 'orange', fontSize: '12px' }}>Both</span>
                                    </label>
                                </div>
                                <div className="w-1/4 mr-4" style={{ marginLeft: '5px' }}>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        PAN Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="PanNumber"
                                        value={formData.PanNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="PAN Number"

                                    />
                                </div>


                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Contact Number 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="ContactNumber1"
                                        value={formData.ContactNumber1}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Contact Number1"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Contact Number 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="ContactNumber2"
                                        value={formData.ContactNumber2}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Contact Number2"

                                    />
                                </div>


                            </div>



                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="Email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Email"

                                    />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        AddressLine 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='AddressLine1'
                                        value={formData.AddressLine1}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="AddressLine 1"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        AddressLine 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='AddressLine2'
                                        value={formData.AddressLine2}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="AddressLine 2"

                                    />
                                </div>
                            </div>
                            <div className="w-full mb-4 flex">
                                <div className="w-full mb-3 flex">
                                    <div className="w-1/2 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                            Delivery AddressLine 1
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={formData.DeliveryAddressLine1}
                                            onChange={handleChange}
                                            type="text"
                                            name='DeliveryAddressLine1'
                                            placeholder="Delivery AddressLine 1"

                                        />
                                    </div>

                                    <div className="w-1/2 mr-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                            Delivery AddressLine 2
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                            value={formData.DeliveryAddressLine2}
                                            onChange={handleChange}
                                            type="text"
                                            name='DeliveryAddressLine2'
                                            placeholder="Delivery AddressLine 2"

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Location
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='Location'
                                        value={formData.Location}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Location"

                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        PIN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='PinCode'
                                        value={formData.PinCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="PIN Code"

                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Credit Days
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='CreditDays'
                                        value={formData.CreditDays}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Credit Days"

                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                        Credit Limit
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='CreditLimit'
                                        value={formData.CreditLimit}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Credit Limit"

                                    />
                                </div>
                            </div>
                        </>
                    ) : null
                )}

                {/* Bank */}

                {formData.masterType === "Bank" && (
                    selectedMasterType?.label === "Bank" || selectedMasterType?.label === undefined ? (
                        <>
                            {/* First Section */}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/3 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="AccountName"
                                        style={{ color: 'blue' }}
                                    >
                                        Account Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="AccountName"
                                        value={formData.AccountName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Account Name"
                                    />
                                </div>
                                <div className="w-1/3 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="BranchName"
                                        style={{ color: 'blue' }}
                                    >
                                        Branch Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="BranchName"
                                        value={formData.BranchName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Branch Name"
                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="IFSCCode"
                                        style={{ color: 'blue' }}
                                    >
                                        IFSC Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="IFSCCode"
                                        value={formData.IFSCCode}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="IFSC Code"
                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="ContactNumber"
                                        style={{ color: 'blue' }}
                                    >
                                        Contact Number 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="ContactNumber"
                                        value={formData.ContactNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Contact Number 1"
                                    />
                                </div>
                            </div>

                            {/* Second Section */}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/2 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="AddressLine1"
                                        style={{ color: 'blue' }}
                                    >
                                        AddressLine 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="AddressLine1"
                                        value={formData.AddressLine1}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="AddressLine 1"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                        htmlFor="AddressLine2"
                                        style={{ color: 'blue' }}
                                    >
                                        AddressLine 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name="AddressLine2"
                                        value={formData.AddressLine2}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="AddressLine 2"
                                    />
                                </div>
                            </div>
                        </>
                    ) : null
                )}


                {/* Staff */}
                {/* {formData.masterType === "Staff" && ( */}
                {formData.masterType === "Staff" && (
                    selectedMasterType?.label === "Staff" || selectedMasterType?.label === undefined ? (
                        <>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Contact Number 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='ContactNumber1'
                                        value={formData.ContactNumber1}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Contact Number 1"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Contact Number 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='ContactNumber2'
                                        value={formData.ContactNumber2}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Contact Number 2"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='Email'
                                        value={formData.Email}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Email"

                                    />
                                </div>
                                <div className="w-1/4 mr-2 ">
                                    <input
                                        className="mr-2 leading-tight"
                                        type="checkbox"
                                        name='isLoginNeeded'
                                        checked={formData.isLoginNeeded}
                                        onChange={handleChange}
                                    />
                                    <label className="text-base text-black font-bold" htmlFor="isLoginNeeded">
                                        Is Login Needed?
                                    </label>
                                </div>
                            </div>

                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        First Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='FirstName'
                                        value={formData.FirstName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Enter First Name"
                                        maxLength={30}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        Last Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='SecondName'
                                        value={formData.SecondName}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Enter Last Name"
                                        maxLength={30}
                                    />
                                </div>


                            </div>

                            <div className="w-full mb-4 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        AddressLine 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='AddressLine1'
                                        value={formData.AddressLine1}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="AddressLine 1"

                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                        AddressLine 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        name='AddressLine2'
                                        value={formData.AddressLine2}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="AddressLine 2"

                                    />
                                </div>
                            </div>
                        </>
                    ) : null
                )}

                {/* AccountHead */}
                {/* {formData.masterType === "Account Head" && ( */}
                {formData.masterType === "Account Head" && (
                    selectedMasterType?.label === "Account Head" || selectedMasterType?.label === undefined ? (
                        <>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                        CGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CGSTRate}
                                        onChange={handleChange}
                                        name="CGSTRate"
                                        type="text"
                                        placeholder="CGST Rate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                        SGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.SGSTRate}
                                        onChange={handleChange}
                                        name="SGSTRate"
                                        type="text"
                                        placeholder="SGst Rate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.HSNCode}
                                        onChange={handleChange}
                                        name="HSNCode"
                                        type="text"
                                        placeholder="HSN Code"

                                    />
                                </div>

                                <div className="w-1/4 mb-4 flex justify-end items-center">
                                    <div className="flex justify-end items-center">

                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Income">
                                            <input
                                                type="radio"
                                                name="IsExpenseOrIncome"
                                                value="true"
                                                checked={formData.IsExpenseOrIncome === true}
                                                onChange={(e) =>
                                                    handleChange({
                                                        target: {
                                                            name: 'IsExpenseOrIncome',
                                                            value: e.target.value === 'true', // Convert string to boolean
                                                        },
                                                    })
                                                }
                                                style={{ marginLeft: '-25px' }}
                                            />
                                            <span style={{ color: 'darkgreen', fontSize: '12px' }}>Income</span>
                                        </label>

                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Expense">
                                            <input
                                                type="radio"
                                                name="IsExpenseOrIncome"
                                                value="false"
                                                checked={formData.IsExpenseOrIncome === false}
                                                onChange={(e) =>
                                                    handleChange({
                                                        target: {
                                                            name: 'IsExpenseOrIncome',
                                                            value: e.target.value === 'true', // Convert string to boolean
                                                        },
                                                    })
                                                }
                                                style={{ marginLeft: '25px' }}
                                            />
                                            <span style={{ color: 'brown', fontSize: '12px' }}>Expense</span>
                                        </label>

                                    </div>
                                </div>

                            </div>
                        </>
                    ) : null
                )}

                {/* Assets */}
                {/* {formData.masterType === "Assets" && ( */}
                {formData.masterType === "Assets" && (
                    selectedMasterType?.label === "Assets" || selectedMasterType?.label === undefined ? (
                        <>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Amount}
                                        onChange={handleChange}
                                        name="Amount"
                                        type="text"
                                        placeholder="Amount"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        Depreciation
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.Depreciation}
                                        onChange={handleChange}
                                        name="Depreciation"
                                        type="text"
                                        placeholder="Depreciation"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        CGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CGSTRate}
                                        onChange={handleChange}
                                        name="CGSTRate"
                                        type="text"
                                        placeholder="CGSTRate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        SGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.SGSTRate}
                                        onChange={handleChange}
                                        name="SGSTRate"
                                        type="text"
                                        placeholder="SGSTRate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.HSNCode}
                                        onChange={handleChange}
                                        name="HSNCode"
                                        type="text"
                                        placeholder="HSN Code"

                                    />
                                </div>
                            </div>
                        </>
                    ) : null
                )}


                {/* Master Type Wise Display the Feilds */}

                {/* Captial */}

                {/* {selectedMasterType?.label === "Capital" && formData.masterType !== "Capital" && ( */}
                {selectedMasterType?.label === "Capital" && formData.masterType !== "Capital" && (
                    <>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    ContactNumber1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={ContactNumber1}
                                    onChange={(e) => setContactNumber1(e.target.value)}
                                    type="text"
                                    placeholder="ContactNumber1"
                                    id="ContactNumber1"
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    ContactNumber2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={ContactNumber2}
                                    onChange={(e) => setContactNumber2(e.target.value)}
                                    type="text"
                                    placeholder="ContactNumber2"
                                    id="ContactNumber2"
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    Email
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={Email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="text"
                                    placeholder="Email"
                                    id="Email"
                                />
                            </div>
                        </div>



                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    AddressLine1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={AddressLine1}
                                    onChange={(e) => setAddressLine1(e.target.value)}
                                    type="text"
                                    placeholder="AddressLine1"
                                    id="AddressLine1"
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    AddressLine2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={AddressLine2}
                                    onChange={(e) => setAddressLine2(e.target.value)}
                                    type="text"
                                    placeholder="AddressLine2"
                                    id="AddressLine2"
                                />
                            </div>
                        </div>
                    </>
                )}

                {/* Customer&Supplier */}

                {/* {selectedMasterType?.label === "Customer Or Supplier" && formData.masterType !== "Customer Or Supplier" && formData.masterType && ( */}
                {selectedMasterType?.label === "Customer Or Supplier" && formData.masterType !== "Customer Or Supplier" && (
                    <>
                        <div className="w-full mb-4 flex justify-start items-start">
                            {/* <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold">
                                    Customer Type
                                </label> */}

                            <div className="w-1/4 mr-2">

                                <label className="block uppercase tracking-wide  text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Invoice Type
                                </label>

                                <Select
                                    value={selectedInvoiceType}
                                    onChange={handleInvoiceTypeChange}
                                    options={InvoiceTypeOptions}
                                    placeholder="Invoice Type"
                                    isSearchable
                                />

                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    GST Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={GSTNumber}
                                    onChange={(e) => setGSTNumber(e.target.value)}
                                    type="text"
                                    placeholder="GST Number"

                                />
                            </div>
                            <div className="flex justify-end items-center">
                                <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                                    <input
                                        type="radio"
                                        name="customerType"
                                        value="1"
                                        checked={customerType === "1"}
                                        onChange={handleChange}
                                    />
                                    <span style={{ color: 'blue', fontSize: '12px' }}>Customer</span>
                                </label>
                                <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                                    <input
                                        type="radio"
                                        name="customerType"
                                        value="2"
                                        checked={customerType === "2"}
                                        onChange={handleChange}
                                    />
                                    <span style={{ color: 'brown', fontSize: '12px' }}>Supplier</span>
                                </label>
                                <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                                    <input
                                        type="radio"
                                        name="customerType"
                                        value="3"
                                        checked={customerType === "3"}
                                        onChange={handleChange}
                                    />
                                    <span style={{ color: 'orange', fontSize: '12px' }}>Both</span>
                                </label>
                            </div>
                        </div>


                        <div className="w-full mb-4 flex">

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    PAN Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={PanNumber}
                                    onChange={(e) => setPanNumber(e.target.value)}
                                    type="text"
                                    placeholder="PAN Number"

                                />
                            </div>


                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Contact Number 1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CSContactNumber1}
                                    onChange={(e) => setCSContactNumber1(e.target.value)}
                                    type="text"
                                    placeholder="Contact Number1"

                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Contact Number 2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CSContactNumber2}
                                    onChange={(e) => setCSContactNumber2(e.target.value)}
                                    type="text"
                                    placeholder="Contact Number2"

                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Email
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CSEmail}
                                    onChange={(e) => setCSEmail(e.target.value)}
                                    type="text"
                                    placeholder="Email"

                                />
                            </div>
                        </div>


                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    AddressLine 1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CSAddressLine1}
                                    onChange={(e) => setCSAddressLine1(e.target.value)}
                                    type="text"
                                    placeholder="AddressLine 1"

                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    AddressLine 2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CSAddressLine2}
                                    onChange={(e) => setCSAddressLine2(e.target.value)}
                                    type="text"
                                    placeholder="AddressLine 2"

                                />
                            </div>
                        </div>

                        <div className="w-full mb-3 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Delivery AddressLine 1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CSDeliveryAddressLine1}
                                    onChange={(e) => setCSDeliveryAddressLine1(e.target.value)}
                                    type="text"
                                    placeholder="Delivery AddressLine 1"

                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Delivery AddressLine 2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CSDeliveryAddressLine2}
                                    onChange={(e) => setCSDeliveryAddressLine2(e.target.value)}
                                    type="text"
                                    placeholder="Delivery AddressLine 2"

                                />
                            </div>
                        </div>
                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Location
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={Location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    type="text"
                                    placeholder="Location"

                                />
                            </div>

                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    PIN Code
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={Pincode}
                                    onChange={(e) => setPincode(e.target.value)}
                                    type="text"
                                    placeholder="PIN Code"

                                />
                            </div>
                            {/* <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    MRPL Code
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={MRPLCode}
                                    onChange={(e) => setMRPLCode(e.target.value)}
                                    type="text"
                                    placeholder="MRPL Code"

                                />
                            </div> */}
                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Credit Days
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CreditDays}
                                    onChange={(e) => setCreditDays(e.target.value)}
                                    type="text"
                                    placeholder="Credit Days"

                                />
                            </div>
                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-0" htmlFor="HSNCode" style={{ color: 'brown' }}>
                                    Credit Limit
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={CreditLimit}
                                    onChange={(e) => setCreditLimit(e.target.value)}
                                    type="text"
                                    placeholder="Credit Limit"

                                />
                            </div>
                        </div>
                    </>
                )}


                {/* Bank */}
                {selectedMasterType?.label === "Bank" && formData.masterType !== "Bank" && formData.masterType && (
                    <div className="w-full mb-4 flex">
                        <div className="w-1/3 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                Account Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={AccountName}
                                onChange={(e) => setAccountName(e.target.value)}
                                type="text"
                                placeholder="Account Name"

                            />
                        </div>
                        <div className="w-1/3 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                Branch Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={BranchName}
                                onChange={(e) => setBranchName(e.target.value)}
                                type="text"
                                placeholder="Branch Name"

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                IFSC Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={IFSCCode}
                                onChange={(e) => setIFSCCode(e.target.value)}
                                type="text"
                                placeholder="IFSC Code"

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                Contact Number 1
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={BKContactNumber}
                                onChange={(e) => setBKContactNumber(e.target.value)}
                                type="text"
                                placeholder="Contact Number 1"

                            />
                        </div>

                    </div>
                )}
                {selectedMasterType?.label === "Bank" && formData.masterType !== "Bank" && formData.masterType && (
                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                AddressLine 1
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={BKAddressLine1}
                                onChange={(e) => setBKAddressLine1(e.target.value)}
                                type="text"
                                placeholder="AddressLine 1"

                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'blue' }}>
                                AddressLine 2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={BKAddressLine2}
                                onChange={(e) => setBKAddressLine2(e.target.value)}
                                type="text"
                                placeholder="AddressLine 2"

                            />
                        </div>
                    </div>
                )}

                {/* Staff */}
                {selectedMasterType?.label === "Staff" && formData.masterType !== "Staff" && formData.masterType && (
                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                Contact Number 1
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STContactNumber1}
                                onChange={(e) => setSTContactNumber1(e.target.value)}
                                type="text"
                                placeholder="Contact Number 1"

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                Contact Number 2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STContactNumber2}
                                onChange={(e) => setSTContactNumber2(e.target.value)}
                                type="text"
                                placeholder="Contact Number 2"

                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                Email
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STEmail}
                                onChange={(e) => setSTEmail(e.target.value)}
                                type="text"
                                placeholder="Email"

                            />
                        </div>
                        <div className="w-1/4 mr-2 ">
                            <input
                                className="mr-2 leading-tight"
                                type="checkbox"
                                checked={isLoginNeeded}
                                onChange={(e) => setIsLoginNeeded(e.target.checked)}
                            />
                            <label className="text-base text-black font-bold" htmlFor="isLoginNeeded">
                                Is Login Needed?
                            </label>
                        </div>
                    </div>
                )}
                {selectedMasterType?.label === "Staff" && formData.masterType !== "Staff" && isLoginNeeded === true && formData.masterType && (
                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                First Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STFirstName}
                                onChange={(e) => setSTFirstName(e.target.value)}
                                type="text"
                                placeholder="Enter First Name"
                                maxLength={30}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                Last Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STSecondName}
                                onChange={(e) => setSTSecondName(e.target.value)}
                                type="text"
                                placeholder="Enter Last Name"
                                maxLength={30}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                User Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STuserName}
                                onChange={(e) => setSTUserName(e.target.value)}
                                type="text"
                                placeholder="Enter User Name"
                                readOnly
                            />
                        </div>
                        <div className="w-1/4 mr-2">

                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                Branch
                            </label>

                            <Select
                                value={selectedBranchType}
                                onChange={handleBranchTypeChange}
                                options={BranchTypeOptions}
                                placeholder="Select Branch"
                                isSearchable
                            />

                        </div>
                    </div>
                )}

                {selectedMasterType?.label === "Staff" && formData.masterType !== "Staff" && formData.masterType && (
                    <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                AddressLine 1
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STAddressLine1}
                                onChange={(e) => setSTAddressLine1(e.target.value)}
                                type="text"
                                placeholder="AddressLine 1"

                            />
                        </div>

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'orange' }}>
                                AddressLine 2
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={STAddressLine2}
                                onChange={(e) => setSTAddressLine2(e.target.value)}
                                type="text"
                                placeholder="AddressLine 2"

                            />
                        </div>
                    </div>
                )}

                {/* AccountHead */}
                {selectedMasterType?.label === "Account Head" && formData.masterType !== "Account Head" && formData.masterType && (
                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                CGST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={CGSTRate}
                                onChange={(e) => setCGSTRate(e.target.value)}
                                type="text"
                                placeholder="CGST Rate"

                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                SGST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={SGSTRate}
                                onChange={(e) => setSGSTRate(e.target.value)}
                                type="text"
                                placeholder="SGst Rate"

                            />
                        </div>


                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'darkmagenta' }}>
                                HSN Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={HSNCode}
                                onChange={(e) => setHSNCode(e.target.value)}
                                type="text"
                                placeholder="HSN Code"

                            />
                        </div>

                        <div className="w-1/4 mb-4 flex justify-end items-center">
                            <div className="flex justify-end items-center">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    <input
                                        type="radio"
                                        name="customerType"
                                        value="true"
                                        checked={IsExpenseOrIncome === true}
                                        onChange={handleAccoundHeadChange}
                                    />
                                    <span style={{ color: 'blue', fontSize: '12px' }}>Income</span>
                                </label>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                    <input
                                        type="radio"
                                        name="customerType"
                                        value="false"
                                        checked={IsExpenseOrIncome === false}
                                        onChange={handleAccoundHeadChange}
                                    />
                                    <span style={{ color: 'brown', fontSize: '12px' }}>Expense</span>
                                </label>
                            </div>
                        </div>

                    </div>
                )}

                {/* Assets */}
                {selectedMasterType?.label === "Assets" && formData.masterType !== "Assets" && formData.masterType && (
                    <div className="w-full mb-4 flex">


                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                Amount
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={ATAmount}
                                onChange={(e) => setATAmount(e.target.value)}
                                type="text"
                                placeholder="Amount"

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                Depreciation
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={ATDepreciation}
                                onChange={(e) => setATDepreciation(e.target.value)}
                                type="text"
                                placeholder="Depreciation"

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                CGST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={ATCGSTRate}
                                onChange={(e) => setATCGSTRate(e.target.value)}
                                type="text"
                                placeholder="CGSTRate"

                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                SGST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={ATSGSTRate}
                                onChange={(e) => setATSGSTRate(e.target.value)}
                                type="text"
                                placeholder="SGSTRate"

                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'red' }}>
                                HSN Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={ATHSNCode}
                                onChange={(e) => setATHSNCode(e.target.value)}
                                type="text"
                                placeholder="HSN Code"

                            />
                        </div>
                    </div>
                )}


            </form >
        </div >
    );
};

export default CapitalEdit;
